import React, { useState } from 'react';
import { updatePassword } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';
import { Card, Input, Button } from '../components/UI';

export default function EditProfileScreen({ user, navigate, showToast }) {
    const [username, setUsername] = useState(user.username || '');
    const [domicile, setDomicile] = useState(user.domicile || '');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [pwdLoading, setPwdLoading] = useState(false);
    const [pwdError, setPwdError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const userDocRef = doc(db, 'users', user.uid);
            await updateDoc(userDocRef, {
                username,
                domicile,
            });
            showToast('Profil berhasil diperbarui!');
            navigate('profile');
        } catch (err) {
            console.error(err);
            setError('Gagal memperbarui profil. Silakan coba lagi.');
            showToast('Gagal memperbarui profil', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handlePasswordChange = async (e) => {
        e.preventDefault();
        setPwdError('');
        if (newPassword !== confirmPassword) {
            setPwdError('Password baru dan konfirmasi tidak cocok.');
            return;
        }
        if (newPassword.length < 6) {
            setPwdError('Password minimal 6 karakter.');
            return;
        }
        
        setPwdLoading(true);
        try {
            await updatePassword(auth.currentUser, newPassword);
            showToast('Password berhasil diubah!', 'success');
            setNewPassword('');
            setConfirmPassword('');
        } catch (err) {
            console.error(err);
            if (err.code === 'auth/requires-recent-login') {
                setPwdError('Demi keamanan, silakan logout dan login kembali sebelum mengganti password.');
            } else {
                setPwdError(err.message.replace('Firebase: ', ''));
            }
            showToast('Gagal mengubah password', 'error');
        } finally {
            setPwdLoading(false);
        }
    };

    return (
        <div className="space-y-6 pb-20">
            <Card>
            <form onSubmit={handleSubmit} className="space-y-4">
                <h2 className="text-2xl font-bold text-brand-dark mb-4 text-center">Edit Profil</h2>
                {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                <Input id="username" type="text" label="Nama Lengkap" value={username} onChange={e => setUsername(e.target.value)} required />
                <Input id="domicile" type="text" label="Domisili (Kota/Kabupaten)" value={domicile} onChange={e => setDomicile(e.target.value)} required />
                <Button type="submit" disabled={loading}>{loading ? 'Menyimpan...' : 'Simpan Perubahan'}</Button>
            </form>
        </Card>

        <Card>
            <form onSubmit={handlePasswordChange} className="space-y-4">
                <h2 className="text-xl font-bold text-brand-dark mb-4 text-center">Ganti Password</h2>
                {pwdError && <p className="bg-red-100 text-red-700 p-3 rounded-lg text-sm">{pwdError}</p>}
                <Input id="newPassword" type="password" label="Password Baru" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
                <Input id="confirmPassword" type="password" label="Konfirmasi Password Baru" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
                <Button type="submit" variant="secondary" disabled={pwdLoading}>{pwdLoading ? 'Menyimpan...' : 'Ubah Password'}</Button>
            </form>
        </Card>
        </div>
    );
}
